import { Loader2 } from "lucide-react";
import type { User } from "@/lib/users.api";
import type { UsersPageViewMode } from "../usersPage.constants";
import { UserGrid } from "./UserGrid";
import { UsersTable } from "./UsersTable";

interface UsersPageContentProps {
  users: User[];
  viewMode: UsersPageViewMode;
  isLoading: boolean;
  busyId: number | null;
  onEdit: (user: User) => void;
  onResetOtp: (user: User) => void;
  onToggleActivation: (user: User) => void;
}

export function UsersPageContent({
  users,
  viewMode,
  isLoading,
  busyId,
  onEdit,
  onResetOtp,
  onToggleActivation,
}: UsersPageContentProps) {
  if (isLoading) {
    return <Loader2 className="animate-spin text-subtle" size={18} />;
  }

  if (viewMode === "grid") {
    return (
      <UserGrid
        users={users}
        busyId={busyId}
        onEdit={onEdit}
        onResetOtp={onResetOtp}
        onToggleActivation={onToggleActivation}
      />
    );
  }

  return (
    <UsersTable
      users={users}
      isLoading={isLoading}
      busyId={busyId}
      onEdit={onEdit}
      onResetOtp={onResetOtp}
      onToggleActivation={onToggleActivation}
    />
  );
}
